import {notifications} from '@mantine/notifications';
import {COLOR_SUB} from '../../../config/constants/colorCodes';

type Props = {
  title?: string;
  message?: string;
};

export const showWarningSnackBar = ({title = '注意', message = ''}: Props) => {
  notifications.show({
    title,
    message,
    styles: () => ({
      root: {
        backgroundColor: COLOR_SUB,
        borderColor: COLOR_SUB,
        color: '#fff',
        '&::before': {backgroundColor: '#fff'},
      },
      title: {color: '#fff'},
      description: {color: '#fff'},
      closeButton: {
        color: '#fff',
        '&:hover': {backgroundColor: COLOR_SUB, opacity: 0.9},
      },
    }),
  });
};
